

import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import notFoundImg from '../assets/pagenotfound.jpg';
import { palette, theme as colorTheme} from '../Convoze.theme';


const primary = colorTheme('palette','primary').value;

/* ----------  styled button  ---------- */
const FillButton = styled(Button)(({ theme }) => ({
  /* default state */
  border: `1px solid ${primary}`,
  color: primary,
  background: 'transparent',
  transition: 'all .4s ease-in-out',
  backgroundSize: '200% 100%',
  backgroundPosition: '100% 0',
  backgroundImage: `linear-gradient(to right, ${primary} 50%, transparent 50%)`,


  /* hover state */
  '&:hover': {
    borderColor: 'transparent',
    backgroundPosition: '0 0',
    color: '#fff',
  },
}));



export default function PageNotFound() {
  const nav = useNavigate();

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          maxWidth: '100%',
          maxHeight: '100%',
          textAlign: 'center',
        }}
      >
        <Box
          component="img"
          src={notFoundImg}
          alt="Page not found"
          sx={{
            width: '100%',
            height: 'auto',
            maxHeight: '70vh',
            objectFit: 'contain',
            borderRadius: 2,
            borderColor:primary
          }}
        />

        <FillButton
          variant="outlined"
          size="large"
          onClick={() => nav('/user/dashboard')}
          sx={{
            mt: 4,
            px: { xs: 3, sm: 4 },
            py: 1.2,
            fontSize: { xs: '0.95rem', sm: '1rem' },
            borderRadius: 50,
            boxShadow: 3,
            textTransform: 'none',
          }}
        >
          Back to Home
        </FillButton>
      </Box>
    </Box>
  );
}